import { getCompany } from "api";
import { useQuery } from "@tanstack/react-query";

// eslint-disable-next-line
const useQueryCompany = (id: string, options?: any) => {
  return useQuery(["merchant", id], () => getCompany(id), options);
};

export default useQueryCompany;
